import { listaDias, listaHoras } from '../detalle-espacio/listas';
import { FormGroup } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-horario',
  templateUrl: './horario.component.html',
  styleUrls: ['./horario.component.scss']
})
export class HorarioComponent implements OnInit {
  
  @Input() formGroup: FormGroup;
  listaDias: string[] = listaDias;
  listaHoras: string[] = listaHoras;

  constructor() { }

  ngOnInit(): void {
  }

  public numSequence(n: number): Array<number> {
    return Array(n);
  }

  
  public borrarHorario() {
    this.formGroup.get("eliminado").setValue(true);
  }

  get estado() {
    return this.formGroup.get("estado").value;
  }

  public cambiarEstado(nuevoEstado: boolean) {
    this.formGroup.get("estado").setValue(nuevoEstado);
  }

}
